<script lang="ts">
  import { fade } from 'svelte/transition';

  import type { TeoText } from '@/teoCore/text/TeoText';
  import { useCoreStore } from '@/ui/state/use-core-state.svelte';
  import { useActiveTeoText } from '@/ui/state/use-text-state.svelte';

  import Editor from './Editor.svelte';

  let { text }: { text: TeoText } = $props();
  let CS = useCoreStore();

  let T = useActiveTeoText();
  let TS = $derived($T.store);

  function getMode() {
    if ($TS.performanceMode === 'autoAI' && $TS.view === 'performance') {
      return 'autoAI' as const;
    }
    if ($TS.view === 'text-generator') {
      return 'generator' as const;
    }
    return 'editor' as const;
  }

  let mode = $derived(getMode());
  let AS = $derived(text.ai.auto.store);
  let workText = $derived($AS.workTextId !== null ? text.ai.auto.workText : null);
</script>

{#key text.id}
  {#if $CS.initialized && $TS.view !== 'new'}
    <div class="h-full max-h-full" transition:fade={{ duration: 200 }}>
      <Editor {text} {mode} />
    </div>
  {/if}
  <!-- The auto loop reads and replaces paragraphs through an editor of its own text. -->
  {#if workText}
    {#key workText.id}
      <div class="hidden">
        <Editor text={workText} mode="autoAIWork" />
      </div>
    {/key}
  {/if}
{/key}
